module.exports = __webpack_public_path__ + "img/car-mirrors.e955f849.svg";